import { connect } from 'react-redux'

import { errorUser } from '../../selectors/currentUser'

/**
 * ErrorUser component
 *
 * @param {Object} props
 * @param {Function} [props.children]
 * @param {Object} [props.reduxErrorUser]
 *
 * @returns {JSX.Element}
 */
const ErrorUser = ({ children, reduxErrorUser }) => children({ errorUser: reduxErrorUser })

const mapStateToProps = state => ({
  reduxErrorUser: errorUser(state),
})

export default connect(mapStateToProps)(ErrorUser)
